<template>
  <div class="box5"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.box5 {
  width: 100%;
  background: url("../../../assets/coursePage/dataAnalysis/box5/banner.png")
    no-repeat;
  background-size: cover;
  height: 280px;
}
</style>
